import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll the window to the top whenever the route path changes. Mounted once
// inside <BrowserRouter> (see App.js) so every route inherits scroll-reset-on-
// navigate — replaces the per-page useEffect(() => window.scrollTo(0,0), [])
// ritual that used to be copy-pasted into each top-level page. (BL-002)
//
// Resets on EVERY navigation, including Back/Forward. We considered preserving
// scroll on Back, but reliable restoration isn't achievable here — list pages
// re-fetch their data, so at POP time the page is empty and there's nothing to
// restore to; a POP-skip only made Back inconsistent (restored on instant
// pages, top on data-loading lists). Consistent reset-all is the chosen
// behavior. (BL-002; impl-review/test-impl decision)
//
// Keyed on pathname only (not search/hash) so ?query changes and #anchor jumps
// don't force a scroll-to-top. Intra-page/step scroll resets (employee wizard
// steps, ProcessPayroll) are NOT replaced by this — they fire on step change
// within a single route, which a pathname-keyed effect never sees.
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
